module.exports = __webpack_public_path__ + "img/the-material-theory-of-induction-cover.26db1ed3.jpg";